export const getCountUpDigit = (number?: number) => {
  if (!number) return 0;
  const digitCharCount = number.toString().length;
  if (digitCharCount >= 4) return digitCharCount + 1;
  if (digitCharCount >= 7) return digitCharCount + 2;
  if (digitCharCount >= 10) return digitCharCount + 3;
  return digitCharCount;
};
